import { Box, Text } from '@streamelements/frontend-ui';

export function CanvasNotFound({ error }: { error: Error }) {
  return (
    <Box
      css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}
    >
      <Text.Heading level="3">Canvas not found</Text.Heading>
      <Text.Body>The canvas you are trying to access does not exist.</Text.Body>
      <Text.Subtitle css={{ margin: '$48', mt: '$48', textAlign: 'center', color: '$textError' }}>{error.toString()}</Text.Subtitle>     
    </Box>
  );
}
